import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Currency } from '../models/enums/UserRole';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private displayCurrencySubject = new BehaviorSubject<Currency>(Currency.Dollar);
  displayCurrency$ = this.displayCurrencySubject.asObservable();

  private readonly rates: Record<Currency, number> = {
    [Currency.Dollar]: 85,
    [Currency.Rupee]: 1,
    [Currency.Euro]: 92,
    [Currency.Pound]: 107,
  };

  setCurrency(currency: Currency) {
    this.displayCurrencySubject.next(currency);
  }

  getCurrency(): Currency {
    return this.displayCurrencySubject.value;
  }

  convertAmount(amount: number, fromCurrency: Currency, toCurrency: Currency): number {
    if (fromCurrency === toCurrency) return amount;
    const amountInRupee = amount * (this.rates[fromCurrency] ?? 1);
    return amountInRupee / (this.rates[toCurrency] ?? 1);
  }
}